export const LOCALES = ['ar', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'ar';

/** Text direction per locale — drives `dir` on `<html>` and the whole RTL layout. */
export const LOCALE_DIRECTION: Record<Locale, 'rtl' | 'ltr'> = {
  ar: 'rtl',
  en: 'ltr',
};

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'ar' || value === 'en';
}
